import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import classes from "./Features.module.css"

import Oval from "../../../../../components/Frame/Frame";
import {Check, Donut, Location, Rotate} from "../../../../../components/Icons/Icons";
import {Fade} from "react-awesome-reveal";

const Features = (props) => {
    return (
        <section className={`${classes.feature}  ${(props.dark) ?  `dark ${classes.dark}` : ''}`}>
            <ListGroup className={classes.listGroup}>
                    <ListGroup.Item className={classes.item}>
                        <Fade top delay={100} triggerOnce={true}>
                        <Oval variant="large">
                            <Location/>
                        </Oval>
                        <p className="text">Geography based order routing</p>
                        </Fade>
                    </ListGroup.Item>
                <ListGroup.Item className={classes.item}>
                    <Fade top delay={150} triggerOnce={true}>
                    <Oval variant="large">
                        <Rotate/>
                    </Oval>
                    <p className="text">Subscription plans for recurring orders</p>
                    </Fade>
                </ListGroup.Item>
                <ListGroup.Item className={classes.item}>
                    <Fade top delay={200} triggerOnce={true}>
                    <Oval variant="large">
                        <Donut/>
                    </Oval>
                    <p className="text">HIPAA compliance</p>
                    </Fade>
                </ListGroup.Item>
                <ListGroup.Item className={classes.item}>
                    <Fade top delay={200} triggerOnce={true}>
                    <Oval variant="large">
                        <Check/>
                    </Oval>
                    <p className="text">Prescription workflows</p>
                    </Fade>
                </ListGroup.Item>
            </ListGroup>
        </section>
    )
}

export default Features